import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import AnimatedTelegramSticker from "~/core-ui/vue/chat/content/AnimatedTelegramSticker.vue";
import {computed} from "vue";
import {internationalUrlIfNeeded} from "~/core-ui/ts/Constants";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "OnlineMessageStickerContent"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    sticker: {}
  },
  emits: ["height-change"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let url = computed(() => internationalUrlIfNeeded(props.sticker.url))

return (_ctx: any,_cache: any) => {
  return (__props.sticker.isTgs)
    ? (_openBlock(), _createBlock(AnimatedTelegramSticker, {
        key: 0,
        url: _unref(url),
        height: 180,
        width: 180,
        onHeightChange: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('height-change')))
      }, null, 8, ["url"]))
    : (__props.sticker.isStaticImage)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _unref(url),
          style: {"max-height":"180px","max-width":"100%"},
          onLoad: _cache[1] || (_cache[1] = ($event: any) => (_unref(emits)('height-change')))
        }, null, 40, _hoisted_1))
      : _createCommentVNode("", true)
}
}

})